<template>
    <div>
        <b-container fluid>
            <b-row>
                <b-col>
                    <b-btn variant="primary" @click="$bus.$emit('client-broadcast-message-form.open')"><i class="fa fa-plus"></i> Nueva Circular Informativa</b-btn>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <app-broadcast-message-list :messages="messages" @sort="onSort" />
                </b-col>
            </b-row>
        </b-container>
        <app-pop-up
            title="Formulario de Circular informativa"
            id="client-broadcast-message-form"
            size="large"
        >
            <template slot="body">
                <app-broadcast-message-form
                    @on-save="closeForm"
                />
            </template>
            <template slot="buttons">
                <b-btn
                    variant="confirm"
                    @click="$bus.$emit('client-broadcast-message-form.save')"
                    :disabled="inProgress"
                ><i class="fa fa-save"></i> Guardar</b-btn>
            </template>
        </app-pop-up>
    </div>
</template>
<script>
import BroadcastMessageList from './BroadcastMessageList/BroadcastMessageList';
import BroadcastMessageForm from './BroadcastMessageForm/BroadcastMessageForm'
import broadcastMessagesRepository from '../../../repositories/broadcastMessages.repository';
export default {
    name: 'broadcast_messages',
    components: {
        appBroadcastMessageList: BroadcastMessageList,
        appBroadcastMessageForm: BroadcastMessageForm,
    },
    data: () => ({
        messages: [],
        page: 1,
        sortBy: '',
        sortDir: ''
    }),
    computed: {

    },
    methods: {
        closeForm() {
            this.$bus.$emit('client-broadcast-message-form.close');
            this.loadMessages();
        },
        async loadMessages() {
            const bmr = {...broadcastMessagesRepository};
            try {
                const {data} = await bmr.getClientBroadcastMessages(this.page, {client: this.client.id, sortBy: this.sortBy, sortDir: this.sortDir});

                this.messages = data.data.map(item => ({...item, _showDetails: true}));
            } catch(err) {
                toastr.error(`Ocurrió un error al cargar las circulares [${err.message}]`);
            }
        },
        onSort(sortData) {
            this.page = 1;
            this.sortBy = sortData.sortBy;
            this.sortDir = sortData.sortDir;
            this.loadMessages();
        }
    },
    created() {
        this.loadMessages();
    }
}

</script>